export enum RETURN_TYPE {
    RETURN = 'RETURN',
    BUYBACK = 'BUYBACK',
    REFUSAL = 'REFUSAL',
}
